import NotEmptyRule from "./NotEmptyRule";

export function createRequiredRule(message: string) {
  return (value: unknown) => !!value || message;
}

export function createDateNotBeforeRule(
  getStartDate: () => string | undefined,
  message: string
) {
  return (value: string | undefined) => {
    const startDate = getStartDate();

    return !value || !startDate || value >= startDate || message;
  };
}

export const ValidationRules = {
  NotEmpty: NotEmptyRule,
  Required: createRequiredRule,
  DateNotBefore: createDateNotBeforeRule,
};

export function getUserAvatarRules() {
  const avatarMaxUploadSize = 100000;
  return [
    (v: File) =>
      !v ||
      v.size < avatarMaxUploadSize ||
      `Soubor musí mít méně než ${avatarMaxUploadSize / 1000000} MB`,
  ];
}
